// AES加密
import * as CryptoJS from 'crypto-js';
const AES_PRIVATE_KEY = import.meta.env.VITE_GLOB_AES_PRIVATE_KEY;
const AES_KEY = CryptoJS.enc.Utf8.parse(AES_PRIVATE_KEY);
const AES_IV = CryptoJS.enc.Utf8.parse(AES_PRIVATE_KEY);

export const useAES = ['production', 'gray'].includes(import.meta.env.VITE_ENV);

export function encrypt(data: object) {
  return CryptoJS.AES.encrypt(
    typeof data === 'object' ? JSON.stringify(data) : data,
    AES_KEY,
    {
      iv: AES_IV,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  )
  .toString();
}

// AES解密
export function decrypt(data: string) {
  const res = CryptoJS.AES.decrypt(
    data,
    AES_KEY,
    {
      iv: AES_IV,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  )
  .toString(CryptoJS.enc.Utf8);

  try {
    return JSON.parse(res);
  } catch (err) {
    return res;
  }
}